/* AIVIQ menu (sections/aiviq-menu.liquid). Written by hand; the markup and styles come from build/menu/mkmenu.pl.
   Computer (>= 1024 px): the nav is placed in the theme's header. A panel opens on hover after 150 ms or on click,
   Enter and Space; it closes on Esc (focus back on the item), 300 ms after the mouse has left, and on a click outside.
   Phone and tablet: the theme's menu button opens the AIVIQ menu (views: start, Kaffemaskiner, Vand, Airfryere,
   Opskrifter & guides, Support) with search results while typing.
   Preview only: on an unpublished theme, links to pages that have a new template are opened with that template,
   so the whole redesign can be clicked through before launch. On the published theme this part does nothing. */
(function () {
  'use strict';
  /* »Tilmeld dig nyhedsbrevet« (collection Tilbud) points to #nyhedsbrev: the newsletter block in the footer */
  var news = document.querySelector('.footer__newsletter');
  if (news && !document.getElementById('nyhedsbrev')) (news.closest('.footer__section') || news).id = 'nyhedsbrev';
  var root = document.querySelector('[data-am]');
  var header = document.getElementById('SiteHeader');
  var slot = document.querySelector('.header-item--navigation');
  if (!root || !header || !slot) return;
  var html = document.documentElement;
  var nav = root.querySelector('[data-am-nav]');
  var panels = root.querySelector('[data-am-panels]');
  var dim = root.querySelector('[data-am-dim]');
  var sheet = root.querySelector('[data-am-m]');
  slot.appendChild(nav);
  header.appendChild(panels);
  header.appendChild(dim);
  root.hidden = false;
  html.classList.add('am-on');
  var wide = window.matchMedia('(min-width: 1024px)');

  /* ---------- computer: panels ---------- */
  var buttons = Array.prototype.slice.call(nav.querySelectorAll('button[aria-controls]'));
  var current = null, openTimer = 0, closeTimer = 0;
  function panelOf(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }
  function openPanel(btn) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (current === btn) return;
    if (current) { current.setAttribute('aria-expanded', 'false'); current.classList.remove('on'); panelOf(current).hidden = true; }
    current = btn;
    btn.setAttribute('aria-expanded', 'true'); btn.classList.add('on');
    var p = panelOf(btn); p.hidden = false;
    p.style.maxHeight = Math.max(240, window.innerHeight - Math.max(0, header.getBoundingClientRect().bottom)) + 'px';
    dim.hidden = false; html.classList.add('am-open');
  }
  function closePanel(focusBack) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!current) return;
    var btn = current; current = null;
    btn.setAttribute('aria-expanded', 'false'); btn.classList.remove('on'); panelOf(btn).hidden = true;
    dim.hidden = true; html.classList.remove('am-open');
    if (focusBack) btn.focus();
  }
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () { if (current === btn) closePanel(false); else openPanel(btn); });
    btn.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(closeTimer); clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(btn); }, current ? 60 : 150);
    });
    btn.addEventListener('pointerleave', function () { clearTimeout(openTimer); });
  });
  /* links in the nav without a panel (Tilbud): hovering them closes an open panel after the same delay */
  header.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'mouse' || !current || current.hasAttribute('data-asq-btn')) return;
    clearTimeout(closeTimer); closeTimer = setTimeout(function () { closePanel(false); }, 300);
  });
  header.addEventListener('pointerenter', function () { clearTimeout(closeTimer); });
  dim.addEventListener('click', function () { closePanel(false); });
  document.addEventListener('pointerdown', function (e) { if (current && !header.contains(e.target)) closePanel(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (current) { e.preventDefault(); closePanel(true); }
    else if (!sheet.hidden) { e.preventDefault(); closeSheet(); }
  });
  header.addEventListener('focusout', function (e) {
    if (!current) return;
    var to = e.relatedTarget;
    if (to && !nav.contains(to) && !panels.contains(to)) closePanel(false);
  });
  panels.addEventListener('click', function (e) { if (e.target.closest('a[href]')) closePanel(false); });
  wide.addEventListener('change', function () { closePanel(false); if (wide.matches) closeSheet(); });

  /* ---------- phone and tablet: the sheet ---------- */
  var trigger = null, views = Array.prototype.slice.call(sheet.querySelectorAll('[data-am-view]'));
  var logo = header.querySelector('.site-header__logo img');
  function show(id, focus) {
    views.forEach(function (v) { v.hidden = v.getAttribute('data-am-view') !== id; });
    var v = sheet.querySelector('[data-am-view="' + id + '"]');
    var sc = v.querySelector('.am-sc'); if (sc) sc.scrollTop = 0;
    if (focus !== false) { var f = v.querySelector(id === 'root' ? '[data-am-close]' : '.bk'); if (f) f.focus(); }
  }
  function openSheet(from) {
    trigger = from || null;
    sheet.querySelectorAll('[data-am-logo]').forEach(function (img) { if (logo && !img.getAttribute('src')) img.src = logo.currentSrc || logo.src; });
    sheet.classList.remove('is-search');
    sheet.hidden = false; html.classList.add('am-lock'); show('root');
  }
  function closeSheet() {
    if (sheet.hidden) return;
    sheet.hidden = true; html.classList.remove('am-lock');
    if (trigger) trigger.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.mobile-nav-trigger') : null;
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    openSheet(t);
  }, true);
  sheet.addEventListener('click', function (e) {
    var go = e.target.closest('[data-am-go]');
    if (go) { show(go.getAttribute('data-am-go')); return; }
    if (e.target.closest('[data-am-close]')) { closeSheet(); return; }
    if (e.target === sheet) { closeSheet(); return; }
    var a = e.target.closest('a[href]');
    if (a && a.getAttribute('href') !== '#') closeSheet();
  });
  /* tablet: the sheet is a side panel; a click on the dimmed page closes it */
  document.addEventListener('click', function (e) {
    if (sheet.hidden || sheet.contains(e.target)) return;
    if (e.target.closest && e.target.closest('.mobile-nav-trigger')) return;
    e.preventDefault(); e.stopPropagation(); closeSheet();
  }, true);
  /* keep the focus inside the sheet */
  sheet.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var v = sheet.querySelector('[data-am-view]:not([hidden])'); if (!v) return;
    var f = Array.prototype.filter.call(v.querySelectorAll('a[href], button, input'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- search (boards Soeg-panel-*; markup from sections/aiviq-search-panel.liquid) ----------
     The header's search icon opens the panel under the menu on computers and the sheet in search mode on phones.
     Results while typing come from sections/aiviq-search-suggest.liquid through /search/suggest. */
  function suggest(input, onHtml, onClear) {
    var timer = 0, seq = 0;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { seq++; onClear(); return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=aiviq-search-suggest')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            if (mine !== seq) return;
            var res = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-asq-results]');
            if (!res) { onClear(); return; }
            onHtml(res.innerHTML);
          })
          .catch(function () { if (mine === seq) onClear(); });
      }, 220);
    });
  }
  function searchFields(form) {
    [['type', 'product,article'], ['options[prefix]', 'last']].forEach(function (f) {
      if (form.querySelector('input[name="' + f[0] + '"]')) return;
      var h = document.createElement('input'); h.type = 'hidden'; h.name = f[0]; h.value = f[1]; form.appendChild(h);
    });
  }
  var asq = document.querySelector('[data-asq]');
  var form = sheet.querySelector('[data-am-search]');
  var sug = sheet.querySelector('[data-am-sug]');
  var rows = sheet.querySelector('[data-am-rows]');
  var mStart = asq ? asq.querySelector('[data-asq-mstart]') : null;
  if (form && sug && rows) {
    var input = form.querySelector('input[type="search"]');
    searchFields(form);
    input.placeholder = 'Søg efter maskiner, opskrifter og hjælp';
    if (mStart) sug.parentNode.insertBefore(mStart, sug);
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
    suggest(input, function (h) {
      sug.innerHTML = h; sug.hidden = false; rows.hidden = true;
      if (mStart) mStart.classList.add('is-off');
    }, function () {
      sug.hidden = true; sug.innerHTML = ''; rows.hidden = false;
      if (mStart) mStart.classList.remove('is-off');
    });
  }
  var sIcon = header.querySelector('.js-search-header');
  var sPanel = asq ? asq.querySelector('[data-asq-panel]') : null;
  if (sIcon && sPanel) {
    panels.appendChild(sPanel);
    sIcon.setAttribute('aria-controls', 'mm-soeg');
    sIcon.setAttribute('aria-expanded', 'false');
    sIcon.setAttribute('data-asq-btn', '');
    var sForm = sPanel.querySelector('[data-asq-form]'), sInput = sForm.querySelector('input[type="search"]');
    var sStart = sPanel.querySelector('[data-asq-start]'), sOut = sPanel.querySelector('[data-asq-out]');
    var sClear = sPanel.querySelector('[data-asq-clear]');
    var showStart = function () { sOut.hidden = true; sOut.innerHTML = ''; sStart.hidden = false; sClear.hidden = !sInput.value; };
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.js-search-header') : null;
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (wide.matches) {
        if (current === sIcon) { closePanel(true); return; }
        openPanel(sIcon); sInput.focus();
      } else {
        openSheet(t); sheet.classList.add('is-search');
        var mi = form && form.querySelector('input[type="search"]'); if (mi) mi.focus();
      }
    }, true);
    sPanel.querySelector('[data-asq-close]').addEventListener('click', function () { closePanel(true); });
    sClear.addEventListener('click', function () { sInput.value = ''; showStart(); sInput.focus(); });
    sForm.addEventListener('submit', function (e) { if (!sInput.value.trim()) e.preventDefault(); });
    suggest(sInput, function (h) { sOut.innerHTML = h; sOut.hidden = false; sStart.hidden = true; sClear.hidden = false; }, showStart);
    /* arrow keys move through the field and the results */
    sPanel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var list = [sInput].concat(Array.prototype.filter.call(sPanel.querySelectorAll('a.asq-r, a.asq-all, a.asq-chip'), function (el) { return el.offsetParent !== null; }));
      var i = list.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      list[(i + (e.key === 'ArrowDown' ? 1 : list.length - 1)) % list.length].focus();
    });
  }

  /* »Brug chatten«: the shop's chat bubble */
  root.ownerDocument.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.am-s [data-chat]') : null;
    if (!b) return;
    closePanel(false);
    var box = document.getElementById('userlink-chat-bubble-container');
    var el = box && (box.querySelector('button, [role="button"]') || box);
    if (el) el.click(); else window.location.href = 'mailto:info@aiviq.dk';
  });

  /* ---------- preview only: open the new templates from every link ---------- */
  var role = window.Shopify && Shopify.theme && Shopify.theme.role;
  if (role && role !== 'main') {
    var PAGES = { 'tryghed': 'tryghed', 'faq': 'faq', 'retur-reklamation': 'garanti', 'manualer-og-instruktioner': 'brugervejledninger', 'reservedele': 'reservedele', 'om-os': 'om-os' };
    var BLOGS = ['opskrifter', 'guides', 'news'];
    var COLL = { 'espressomaskiner': 'espresso', 'kaffe-espresso': 'kaffe', 'kaffemaskiner': 'kaffemaskiner', 'kapselmaskiner': 'kapsel', 'filter-kaffemaskiner': 'filter',
      'filter-kaffemaskiner-med-indbygget-kvaern': 'filter-kvaern', 'kaffekvaerne': 'kvaerne', 'pour-over-kaffe': 'pour-over', 'maelkeskummer': 'maelk', 'elkedler': 'elkedler',
      'brodrister': 'brod', 'vand-te-morgenmad': 'vand', 'air-fryers': 'airfryer', 'single-basket-airfryer': 'airfryer-en', 'dual-basket-airfryer': 'airfryer-to',
      'tilbehor': 'tilbehor', 'tilbud': 'tilbud', 'aiviq': 'alle' };
    var PDP = (root.getAttribute('data-am-pdp') || '').split(' ');
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank') return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin || u.searchParams.has('view')) return;
      var m;
      if ((m = u.pathname.match(/^\/pages\/([^\/]+)\/?$/)) && PAGES[m[1]]) { u.pathname = '/pages/om-os'; u.searchParams.set('view', 'aiviq-' + PAGES[m[1]]); }
      else if ((m = u.pathname.match(/^\/collections\/([^\/]+)\/?$/)) && COLL[m[1]]) { u.searchParams.set('view', 'aiviq-' + COLL[m[1]]); }
      else if ((m = u.pathname.match(/^\/(?:collections\/[^\/]+\/)?products\/([^\/]+)\/?$/)) && PDP.indexOf(m[1]) >= 0) { u.searchParams.set('view', 'aiviq-pdp'); }
      else if ((m = u.pathname.match(/^\/blogs\/([^\/]+)\/?$/)) && BLOGS.indexOf(m[1]) >= 0) { u.searchParams.set('view', 'aiviq-blog'); }
      else if ((m = u.pathname.match(/^\/blogs\/([^\/]+)\/[^\/]+\/?$/)) && BLOGS.indexOf(m[1]) >= 0) { u.searchParams.set('view', 'aiviq-article'); }
      else return;
      a.href = u.toString();
    }, true);
  }
})();
